import moment from 'moment';

export function formatDate(date: string | Date | null, option = {}) {
  const options = {
    format: 'MM/DD/YYYY HH:mm:ss',
    utc: true,
    append: null,
    ...option,
  };

  const { format, utc } = options;

  if (!date) {
    return options.append;
  }
  if (utc) {
    return moment(date).utc().format(format);
  }
  return moment(date).format(format);
}

export const formatTimeout = (timeout_seconds: number | null) => {
  const hours = timeout_seconds && Math.floor(timeout_seconds / 3600);
  const minute_seconds = timeout_seconds && timeout_seconds % 3600;
  const minutes = minute_seconds && Math.floor(minute_seconds / 60);
  const seconds = minute_seconds && minute_seconds % 60;

  const hours_formatted = String(hours).padStart(2, '0');
  const minutes_formatted = String(minutes).padStart(2, '0');
  const seconds_formatted = String(seconds).padStart(2, '0');
  return `${hours_formatted}:${minutes_formatted}:${seconds_formatted}`;
};

export const offsetTimezoneLocal = <TOption>(date: string | null, option: TOption): string | null => {
  const options = {
    format: 'M/D/YYYY hh:mm A',
    local_timezone: true,
    decrement: 0,
    type: 'days',
    ...option,
  };
  const { format, local_timezone, decrement, type } = options;

  const valid = moment(date).isValid();

  if (!valid || !date) {
    return null;
  }

  if (local_timezone) {
    return moment(date).subtract(decrement, type).utc().format(format);
  }
  return moment(date).subtract(decrement, type).format(format);
};

export const offsetTimezoneUTC = <TOption>(date: string | Date | null, option: TOption): string | null => {
  const options = {
    format: 'M/D/YYYY hh:mm A',
    local_timezone: true,
    decrement: 0,
    type: 'days',
    ...option,
  };
  const { format, local_timezone, decrement, type } = options;

  const valid = moment(date).isValid();

  if (!valid || !date) {
    return null;
  }

  const offset = -(moment(date, format).toDate().getTimezoneOffset() / 60);

  if (local_timezone) {
    return moment(date).add(offset, 'hours').subtract(decrement, type).format(format);
  }
  return moment(date).subtract(decrement, type).format(format);
};

export function subtractFromDate<TOption>(date: string | Date | null, option: TOption): string {
  const options = {
    decrement: 0,
    type: 'days',
    utc: true,
    format: 'M/D/YYYY HH:mm:ss',
    ...option,
  };
  const { decrement, type, format, utc } = options;
  if (utc) {
    return moment(date).subtract(decrement, type).utc().format(format);
  }
  return moment(date).subtract(decrement, type).format(format);
}
